import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/libs/shared/pages/docs/Wrapper.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/sites/wpspotlight.pro/src/components/global/animation-container.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/sites/wpspotlight.pro/styles/docs.scss");
